import { type FC, useEffect, useRef } from "react";

export interface Props {
  text: string;
  lines: number;
  children?: never;
}

const ClampedText: FC<Props & JSX.IntrinsicElements["div"]> = (props) => {
  const { text, lines, ...rest } = props;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const div = ref.current;
      const span = div.children[0] as HTMLElement;
      const lh = window.getComputedStyle(div).lineHeight;
      div.style.maxHeight = `calc( ${lines} * ${lh} )`;

      if (text) {
        truncate(div, span);
      }
    }
  }, [text, lines, rest.className, rest.style]);

  return (
    <div ref={ref} {...rest}>
      <span>{text}</span>
    </div>
  );
};
export default ClampedText;

function truncate(div: HTMLElement, span: HTMLElement) {
  const divh = div.clientHeight;
  // Check if the paragraph's height is taller than the container's height. If it is:
  while (span.offsetHeight > divh && span.textContent && span.textContent.trim() !== "...") {
    // add an ellipsis at the last shown space
    span.textContent = span.textContent!.replace(/\W*\s(\S)*$/, "...");
  }
}
